import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import ItemTable from "../../InvoiceGeneration/ItemTable";
import { tableEditIcon } from "../../../assets/images";
import { StageDetailsType } from "../../../commonTypes/clientDirectoryTypes";
import UpdatedByAndUpdatedAt from "../../commons/CommonUpdatedByAndUpdatedAt";
import { formateDateTime } from "../../../utils/commonFunctions";

type AppProps = {
  tableHeader: TableHeadersType[];
  data: StageDetailsType[];
  handleEditData: (data: StageDetailsType) => void;
  styleColor: any;
  blank: any;
};

const LeadThresholdTableData = ({
  tableHeader,
  data,
  handleEditData,
  styleColor,
  blank,
}: AppProps) => {
  return (
    <>
      {data?.length > 0 &&
        data?.map((item: any) => {
          return (
            <tr>
              {tableHeader?.map((header: TableHeadersType) => {
                if (header?.value === "action") {
                  return (
                    <td style={{ width: "50px", textAlign: "center" }}>
                      <div className="d-flex">
                        {
                          <span
                            className="d-inline-block pointer"
                            onClick={() => handleEditData(item)}
                          >
                            <div
                              style={{
                                color: "#d43",
                                fontSize: 20,
                                width: "30px",
                              }}
                            >
                              <img src={tableEditIcon} alt="" />
                            </div>
                          </span>
                        }
                      </div>
                    </td>
                  );
                } else if (header?.value === "updated_by") {
                  return (
                    <td style={{ width: "100px" }}>
                      <UpdatedByAndUpdatedAt
                        firstName={
                          item?.updated_by?.first_name
                            ? item?.updated_by?.first_name
                            : ""
                        }
                        lastName={
                          item?.updated_by?.last_name
                            ? item?.updated_by?.last_name
                            : ""
                        }
                        profilePic={item?.updated_by?.profile_pic?.file_url}
                        updatedAt={formateDateTime(item?.updated_at)}
                      />
                    </td>
                  );
                } else if (header?.value === "stage_name") {
                  return (
                    <td>
                      {
                        <div style={styleColor(item[header?.value])}>
                          {item[header?.value]}
                        </div>
                      }
                    </td>
                  );
                } else {
                  return <td>{item[header?.value]}</td>;
                }
              })}
            </tr>
          );
        })}
    </>
  );
};

export default LeadThresholdTableData;
